module.exports = __webpack_public_path__ + "img/vignette-dpe.6364c622.jpg";